// src/pages/BuscarMoldes.jsx
import axios from "axios";
import { useState } from "react";
import {
  Box,
  Grid,
  TextField,
  Button,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Divider,
} from "@mui/material";

import {
  ModalConfimacao,
  ModalErro,
  ModalLoad,
  ModalSucesso,
} from "../../components/models/models";
import global from "../../utils/global";
import {
  tratamentoErro,
  getToken,
} from "../../utils/utils";
import { MdOutlineEdit } from "react-icons/md";
import { AiFillDelete } from "react-icons/ai";

export default function BuscarMoldes({ user }) {
  const [nomeMolde, setNomeMolde] = useState("");
  const [numColunas, setNumColunas] = useState("");

  const [listMoldes, setListMoldes] = useState([]);

  // modal load
  const [showModalLoad, setShowModalLoad] = useState(false);

  // modal erro
  const [showModalErro, setShowModalErro] = useState(false);
  const [msgModalErro, setMsgModalErro] = useState("");
  const [funcPosModalErro, setFuncPosModalErro] = useState(() => () => {});

  // modal sucesso
  const [showModalSucesso, setShowModalSucesso] = useState(false);
  const [msgModalSucesso, setMsgModalSucesso] = useState("");
  const [funcPosModalSucesso, setFuncPosModalSucesso] = useState(() => () => {});

  // modal confirmar acao
  const [showModalConfirmarAcao, setShowModalConfirmarAcao] = useState(false);
  const [msgModalConfirmarAcao, setMsgModalConfirmarAcao] = useState("");
  const [funcPosModalConfirmarAcao, setFuncPosModalConfirmarAcao] = useState(
    () => () => {}
  );

  const funcBuscar = async () => {
    setShowModalLoad(true);

    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url:
        global.baseUrl +
        "/AppEtiqueta/BuscarMoldes?numCol=" +
        numColunas +
        "&nome=" +
        nomeMolde,
      headers: {
        Authorization: await getToken(user.clientKey),
      },
    };

    axios
      .request(config)
      .then((response) => {
        if (response.data.code === 0) {
          setListMoldes(response.data.content);
        } else {
          setMsgModalErro("Erro ao buscar moldes: " + response.data.msg);
          setShowModalErro(true);
        }
      })
      .catch((error) => {
        setMsgModalErro("Erro ao buscar moldes: " + tratamentoErro(error));
        setShowModalErro(true);
      })
      .finally(() => setShowModalLoad(false));
  };

  const funcExcluir = async (uuid) => {
    setShowModalLoad(true);

    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: global.baseUrl + "/AppEtiqueta/ExcluirMolde?id=" + uuid,
      headers: {
        Authorization: await getToken(user.clientKey),
      },
    };

    axios
      .request(config)
      .then((response) => {
        if (response.data.code === 0) {
          setMsgModalSucesso("Molde excluído com sucesso!");
          setShowModalSucesso(true);
          funcBuscar();
        } else {
          setMsgModalErro("Erro ao excluir molde: " + response.data.msg);
          setShowModalErro(true);
        }
      })
      .catch((error) => {
        setMsgModalErro("Erro ao excluir molde: " + tratamentoErro(error));
        setShowModalErro(true);
      })
      .finally(() => setShowModalLoad(false));
  };

  return (
    <Box mx={6}>
        <ModalErro
            showModal={showModalErro}
            setShowModal={setShowModalErro}
            msg={msgModalErro}
            funcPos={funcPosModalErro}
        />
        <ModalSucesso
            showModal={showModalSucesso}
            setShowModal={setShowModalSucesso}
            msg={msgModalSucesso}
            funcPos={funcPosModalSucesso}
        />
        <ModalLoad showModal={showModalLoad} />
        <ModalConfimacao
            showModal={showModalConfirmarAcao}
            setShowModal={setShowModalConfirmarAcao}
            funcPos={funcPosModalConfirmarAcao}
            msgModalConfirmarAcao={msgModalConfirmarAcao}
        />

        <Typography variant="h5" mt={2} mb={1}>
            Buscar moldes
        </Typography>
        <Divider />

        <Grid container spacing={2} mt={1}>
            <TextField
                fullWidth
                label="Nome do molde"
                value={nomeMolde}
                onChange={(e) => setNomeMolde(e.target.value)}
            />
            <TextField
                fullWidth
                type="number"
                label="Número de colunas"
                value={numColunas}
                onChange={(e) => setNumColunas(e.target.value)}
            />
        </Grid>
        <Button variant="contained" color="primary" onClick={funcBuscar} sx={{ mt: 2 }} fullWidth>
            Buscar
        </Button>


        <Divider sx={{ my: 2 }} />

        {listMoldes.length > 0 ? (
            <Table>
            <TableHead>
                <TableRow>
                <TableCell>Nome</TableCell>
                <TableCell>Altura (cm)</TableCell>
                <TableCell>Largura (cm)</TableCell>
                <TableCell>Número de colunas</TableCell>
                <TableCell>Ações</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {listMoldes.map((item) => (
                <TableRow key={item.uuidMoldeEtiqueta}>
                    <TableCell>{item.nomeMolde}</TableCell>
                    <TableCell>{item.altura}</TableCell>
                    <TableCell>{item.largura}</TableCell>
                    <TableCell>{item.numColunas}</TableCell>
                    <TableCell>
                    <IconButton
                        color="primary"
                        onClick={() =>
                        (window.location.href =
                            "/cadastrareditarmolde?id=" + item.uuidMoldeEtiqueta)
                        }
                    >
                        <MdOutlineEdit size={22} />
                    </IconButton>
                    <IconButton
                        color="error"
                        onClick={() => {
                        setFuncPosModalConfirmarAcao(() => () =>
                            funcExcluir(item.uuidMoldeEtiqueta)
                        );
                        setMsgModalConfirmarAcao(
                            "Tem certeza que deseja excluir o molde?"
                        );
                        setShowModalConfirmarAcao(true);
                        }}
                    >
                        <AiFillDelete size={22} />
                    </IconButton>
                    </TableCell>
                </TableRow>
                ))}
            </TableBody>
            </Table>
        ) : (
            <Typography mt={2}>Não há registros</Typography>
        )}
    </Box>
  );
}
